<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer/>
			<v-spacer/>
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				:label="$t('pages.orderFilter.search')"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="clients"
			:loading="loading"
			class="elevation-1"
			:single-expand="false"
			:expanded.sync="expanded"
			show-expand
			:height="height"
			fixed-header
			mobile-breakpoint="0"
			:search="lookingFor"

		>
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<template #item="{item}">
				<client-row @edit="onEdit" @open="open" @branch="createBranch(item)" :key="item.id" :client="item"/>
			</template>

			<template v-slot:expanded-item="{item}">
				<td :colspan="headers.length">
					<client-expand :client="item" @branch="onBranch" @deleteBranch="deleteBranch"/>
				</td>
			</template>

		</v-data-table>
		<popup-dialog v-model="openModal">
			<v-card>
				<branch-form :branch="tempBranch"/>
			</v-card>
		</popup-dialog>
	</v-card>
</template>

<script>
	import ClientRow from "src/view/clients/ClientRow";
	import {types} from "src/store/modules/Client.module";
	import FilterAble from "src/mixins/FilterAble";
	import BranchForm from "dev/view/branches/BranchForm";
	import ClientExpand from "dev/view/clients/ClientExpand";

	export default {
		name: "clients-table",
		props: [],
		components: {
			ClientExpand,
			BranchForm,
			ClientRow
		},
		mixins: [new FilterAble(types)],
		data() {
			return {
				lookingFor: "",
				expanded: [],
				loading: false,
				openModal: false,
				headers: [
					{text: this.$t("pages.orderTable.companyName"), value: "name"},
					{text: this.$t("pages.clientTable.num"), value: "num"},
					{text: this.$t("pages.client.price"), value: "price"},
					{text: this.$t("pages.client.next_price"), value: "next_price"},
					{text: this.$t("pages.client.multiBranches"), value: "num"},
					{text: 'קישור חיצוני', value: "outside_link"},
					{text: this.$t("pages.measurementTable.actions"), value: ""},
				],
				height: 200,
				showDialog: false,
				tempBranch: null,
			};
		},
		computed: {
			clients() {
				return this.$store.state.ClientModule.clients;
			}
		},
		methods: {
			deleteBranch(item){
				this.$emit("deleteBranch", item);
			},

			onEditBrance(item){
				this.openModal=true;
				this.tempBranch=item;
			},
			open(item){
				let index = this.expanded.indexOf(item);
				if (index > -1) {
					this.expanded.splice(index, 1);
				} else {
					this.expanded.push(item);
				}
			},
			onBranch(branch) {
				this.$emit("branch", branch);

			}, createBranch(client) {
				this.$emit("branch", {client_id: client.id});

			},

			onEdit(Client) {
				this.$emit("edit", Client);
			}
		},
		mounted() {
			this.height = window.innerHeight - 100 - this.$el.getBoundingClientRect().y;
		}
	};
</script>

<style>

</style>
